import { useState, useEffect } from 'react';
import { StatutMarital, RegimeMatrimonial, TypeRelation } from '../types/api';
import { apiService } from '../services/api';

export const useReferenceData = () => {
  const [statutsMaritaux, setStatutsMaritaux] = useState<StatutMarital[]>([]);
  const [regimesMatrimoniaux, setRegimesMatrimoniaux] = useState<RegimeMatrimonial[]>([]);
  const [typesRelation, setTypesRelation] = useState<TypeRelation[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchStatutsMaritaux = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiService.getStatutsMaritaux();
      setStatutsMaritaux(response.results);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Erreur lors du chargement des statuts maritaux');
    } finally {
      setLoading(false);
    }
  };

  const fetchRegimesMatrimoniaux = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiService.getRegimesMatrimoniaux();
      setRegimesMatrimoniaux(response.results);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Erreur lors du chargement des régimes matrimoniaux');
    } finally {
      setLoading(false);
    }
  };

  const fetchTypesRelation = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiService.getTypesRelation();
      setTypesRelation(response.results);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Erreur lors du chargement des types de relations');
    } finally {
      setLoading(false);
    }
  };

  const fetchAll = async () => {
    await Promise.all([
      fetchStatutsMaritaux(),
      fetchRegimesMatrimoniaux(),
      fetchTypesRelation()
    ]);
  };

  useEffect(() => {
    fetchAll();
  }, []);

  return {
    statutsMaritaux,
    regimesMatrimoniaux,
    typesRelation,
    loading,
    error,
    fetchStatutsMaritaux,
    fetchRegimesMatrimoniaux,
    fetchTypesRelation,
    fetchAll
  };
};
